var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.594,
    height: 10,
    viewBox: "0 0 6.594 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M8.5 0c1.73 0 3.433.8 3.433 2.7 0 1.757-2.014 2.433-2.446 3.068-.325.472-.216 1.136-1.108 1.136A.86.86 0 0 1 7.516 6c0-1.609 2.364-1.973 2.364-3.3 0-.729-.485-1.162-1.3-1.162-1.73 0-1.054 1.783-2.364 1.783A.809.809 0 0 1 5.34 2.5C5.34 1.175 6.853 0 8.5 0zm-.065 7.783a1.108 1.108 0 1 1-1.109 1.109 1.113 1.113 0 0 1 1.109-1.109z",
    className: "cls-1",
    "data-name": "Path 35",
    transform: "translate(-5.34)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question-mark.3ee763c91a00b9f309e794487b910d06.svg";